<template>
  <div class="c-media-wrapper">
    <!-- filter -->
    <media-filter ref="mediaFilter" slot="filter" :loading="loading" :query-key="queryKey" @on-search="onSearch" @on-add="addMedia" />

    <Viewport v-model="height">
      <!-- table -->
      <m-table ref="table" :data="tableData" :height="height - 40" :loading="loading" @selection-change="changeSelection">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <el-button type="text" @click.prevent="editMedia(scope.row)">编辑</el-button>
            </div>
            <div v-if="col.key === 'field1'">
              <el-switch size="small" :value="scope.row[col.key]" active-value="1" inactive-value="0" @change="changeStatus(scope.row)" />
            </div>
            <el-link v-else-if="col.key === 'field4'" :href="getMediaUrl(scope.row.field4)" target="_blank">{{ scope.row.field4 }}</el-link>
            <span v-else-if="['createTime', 'upTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else-if="col.key === 'status'">{{ scope.row[col.key] | statusSwitch }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </m-table>
      <el-pagination
        class="c-table-page"
        v-if="total"
        :total="total"
        :current-page.sync="pageIndex"
        :page-size="pageSize"
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        background
        @current-change="changePageIndex"
        @size-change="changePageSize"
      />
    </Viewport>

    <!-- 弹出框 -->
    <media-edit v-model="model" title="媒体" :editFlag="editFlag" :editData="editData" :loading="loading" @on-save="saveMedia" />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { setLocal } from '@/common/js/api'
import { queryMedia, addMedia, updateMedia, changeMediaStatus } from '@/api/media-advert.model'
import mixin from '../mixins/mixin'
import MediaFilter from './components/media-filter.vue'
import MediaEdit from './components/media-edit.vue'
import tableColumns from '../data/media_columns'

export default {
  name: 'Media',
  mixins: [mixin],
  components: { MediaFilter, MediaEdit },
  data() {
    return {
      model: null,
      saving: null,
      loading: null,
      height: 0,
      queryKey: null,
      tableData: [],
      tableColumns: [],
      access: this.$store.state.accessAuth,
      selectionRow: [],
      editData: {
        mediaId: null,
        mediaName: '',
        adsName: '',
        loginAddr: '',
        rebate: 1
      },
      editFlag: ''
    }
  },
  mounted() {
    this.getData()
  },
  filters: {
    statusSwitch(val) {
      let status = ''
      if (val === '1') status = '开启'
      else if (val === '0') status = '禁用'
      return status
    }
  },
  methods: {
    changeStatus(val) {
      this.loading = true
      const { status, mediaId } = val
      changeMediaStatus({ status: status === '1' ? '0' : '1', mediaId })
        .then((data) => {
          if (data) {
            this.getData()
          } else this.$message.error('更改状态失败！')
        })
        .catch((err) => console.log(err))
    },
    changeSelection(val) {
      if (isArray(val)) {
        this.selectionRow = val.map((e) => {
          return e
        })
      }
    },
    setLocalPage(size) {
      setLocal('PAGESIZE', size)
    },
    onSearch(params) {
      this.queryKey = params.keyword
      this.getData()
    },
    getMediaUrl(addr) {
      if (!addr) {
        return addr
      }
      if (addr && (addr.toLowerCase().indexOf('http://') === 0 || addr.toLowerCase().indexOf('https://') === 0)) {
        return addr
      }
      return 'http://' + addr
    },
    addMedia() {
      this.editFlag = 'add'
      this.editData = {
        mediaId: null,
        mediaName: '',
        adsName: '',
        loginAddr: '',
        rebate: 1
      }
      this.model = true
    },
    editMedia(row) {
      this.editFlag = 'edit'
      this.editData = {
        mediaId: row.mediaId,
        mediaName: row.mediaName,
        loginAddr: row.field4,
        rebate: row.rebate
      }
      this.model = true
    },
    saveMedia(params) {
      if (this.editFlag === 'add') {
        this.loading = true
        addMedia(params)
          .then((data) => {
            this.loading = false
            if (data) {
              this.$message.success('保存成功!')
              this.model = false
              this.pageIndex = 1
              this.$refs.mediaFilter.setQueryKey('')
              this.getData()
            }
          })
          .catch(() => {
            this.loading = false
            this.$message.error('保存失败!')
          })
      } else if (this.editFlag === 'edit') {
        this.loading = true
        updateMedia(params)
          .then((data) => {
            this.loading = false
            if (data) {
              this.$message.success('保存成功!')
              this.model = false
              this.getData()
            }
          })
          .catch(() => {
            this.loading = false
            this.$message.error('保存失败!')
          })
      }
    },
    getData() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        key: this.queryKey
      }
      this.loading = true
      queryMedia(params)
        .then((data) => {
          this.loading = false
          if (data) {
            if (!data) {
              return
            }
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.pageIndex = page_info.page_id
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-media-wrapper {
  height: 100%;

  .m-edit {
    cursor: pointer;
  }

  .tag-wrap {
    width: 88%;
    display: inline-block;
  }

  ::v-deep .el-tag .el-tag__content {
    width: auto;
  }

  .c-table-page {
    padding: 0 8px;
    margin-top: 6px;
    text-align: right;
  }

  ::v-deep .el-link {
    font-size: 12px;
  }
}
</style>
